module.exports = __webpack_public_path__ + "static/media/covi_del_del_doc.e1c81039.png";